module.exports = __webpack_public_path__ + "static/media/WHallCorner-b.a9698cab.webp";